import { supabase } from './supabase';

interface MailgunMessage {
  to: string;
  from: string;
  subject: string;
  text: string;
  html?: string;
}

/**
 * Serverless function to send email using Mailgun.
 */
export async function sendMailgunEmail(
  to: string, 
  subject: string, 
  body: string, 
  html?: string,
  interactionId?: string
): Promise<{ success: boolean; message: string }> {
  try {
    // get the users email
    const { data: { session } } = await supabase.auth.getSession()
    const userEmail = session?.user.email

    const payload: any = {
      to,
      from: 'Research-X <noreply@research-x.com>',
      subject,
      text: body,
      html: html || body.replace(/\n/g, '<br>'),
    }
    
    // Add CC to user's email
    if (userEmail) payload.cc = userEmail
    
    // Add reply-to address with interaction ID embedded
    if (interactionId) {
      payload['h:Reply-To'] = `reply-${interactionId}@replies.research-x.com`
    }

    // Erase the local host for prod
    const endpoint = import.meta.env.DEV 
      ? 'http://localhost:54321/functions/v1/send-email'
      : 'https://ejrebxlzxiylmljtrzzk.supabase.co/functions/v1/send-email';
    
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Failed to send email');
    }

    return { success: true, message: 'Email sent successfully' };
  } catch (error) {
    console.error('Error sending email:', error);
    return { 
      success: false, 
      message: error instanceof Error ? error.message : 'Failed to send email' 
    };
  }
}